type Listener = () => void;

class PlayheadStore {
  private value = 0;
  private listeners = new Set<Listener>();

  get = (): number => this.value;

  set = (next: number): void => {
    if (this.value === next) return;
    this.value = next;
    this.listeners.forEach(l => l());
  };

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  };
}

export const playheadStore = new PlayheadStore();
